import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Pcr, PcrSort } from '../../lib/types/models/pcr/pcr'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcrs(input: PaginationRequest<never, string, Version, PcrSort> = {}) {
  if (!input.sort) input.sort = { firstName: 'asc', lastName: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.pcr.getAll.url, null), input))
    .get<PaginationResponse<Pcr>>()
}
